export const HOST = 'http://mobile.funnymamu.com/'
export const DOWNLOAD_LINK = 'http://d42hh60ov1ysd.cloudfront.net/4Fun-girls.apk';

export function downloadApk () {
  console.info('download apk')
  location.href = DOWNLOAD_LINK
  // let $iframe = document.createElement('iframe');
  // $iframe.src = DOWNLOAD_LINK;
  // $iframe.style.display = 'block';
  // $iframe.style.height = '0px';
  // $iframe.style.width = '0px';
  // document.body.appendChild($iframe);
  // setTimeout(function () {
  //   $iframe.remove();
  // }, 1500)
}
